import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { useDispatch } from 'react-redux'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MyButton from '../../../../UI/form/MyButton'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import SkuFieldMain from '../../../../form/fields/SkuFieldMain'
import { editSupplyBillItem } from '../../../../../store/supplyBillSlice'
import { editSupplyBillItemSkuAPI } from '../../../../../api/supply/supplyBillItemAPI'

const ChangeSkuForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyBillItemBd ? 
            {
                sku: supplyBillItemBd.sku,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyBillItemSkuAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyBillItemBd.id,
            sku: data.sku,
        }

        return dataForBd
    }


  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('sku', 'supplyBillItemSku') ?
				<SkuFieldMain
					required={formDataProductRequiredField('sku', 'supplyBillItemSku')}
					setValidate={e => updateValidate(setValid, 'sku', e)}
					setValueForm={e => setValueForm(setData, 'sku', e)}
					forciblyValue={data && data.sku ? data.sku : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeSkuForm